// extracted by mini-css-extract-plugin
export default {"button":"Button_button__w6ivb","buttonRect":"Button_buttonRect__ENao8"};